module.exports = __webpack_public_path__ + "static/media/winthrop.d678a56b.png";